import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useLang } from '../i18n'

/** A small accessible confirmation dialog (e.g. delete). Escape cancels. */
export function ConfirmModal({
  title,
  message,
  confirmLabel,
  danger = false,
  onConfirm,
  onClose,
}: {
  title: string
  message: string
  confirmLabel?: string
  danger?: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  const { t } = useLang()
  const confirmRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const prev = document.activeElement as HTMLElement | null
    confirmRef.current?.focus()
    return () => prev?.focus()
  }, [])

  return createPortal(
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div
        className="modal confirm-modal"
        role="alertdialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Escape') onClose()
        }}
      >
        <div className="modal-head">
          <h2>{title}</h2>
          <button className="modal-close" aria-label={t('close')} onClick={onClose}>✕</button>
        </div>
        <div className="modal-body prompt-body">
          <p className="confirm-msg">{message}</p>
          <div className="prompt-acts">
            <button className="mini ghost" onClick={onClose}>{t('cancel')}</button>
            <button
              ref={confirmRef}
              className={danger ? 'mini danger' : 'mini ok'}
              onClick={onConfirm}
            >
              {confirmLabel ?? t('delete')}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  )
}
